import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem('token')
  );
  const BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://urlshortener-serverside.onrender.com/api';

  useEffect(() => {
    const syncUser = async () => {
      const token = localStorage.getItem('token');
      const username = localStorage.getItem('username');
      if (!token || username) return;
      try {
        const response = await axios.get(`${BASE_URL}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data?.username) {
          localStorage.setItem('username', response.data.username);
        }
      } catch (error) {
        // ignore
      }
    };
    syncUser();
  }, [BASE_URL]);

  const login = () => {
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, setIsAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthProvider, AuthContext };
